import React from "react";

//Importing Material UI stuff
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Card } from "@material-ui/core";

import style from "./style";

const AchievementCards = ({ title, description }) => {
  const useStyles = makeStyles(style);
  const classes = useStyles();
  return (
    <Card data-aos="fade-in" className={`${classes.achievementCard}`}>
      <Grid container className={`${classes.textContainer}`}>
        <Typography data-aos="fade-in" className={`${classes.title}`} variant="h5">{title}</Typography>

        <Typography data-aos="fade-in" variant="h6" className={`${classes.description}`}>
          {description}
        </Typography>
      </Grid>
    </Card>
  );
};

export default AchievementCards;
